import * as actionTypes from "../actions/actionTypes";
import { api } from "../../common/api-utils";
import { pathOr,clone } from "ramda";
import { toast } from "react-toastify";

const getError = (res) =>
  pathOr("Something went wrong!", ["data", "errors", "detail"], res);

// List View actions

const getConditionOpertorViewRequest = () => ({
  type: actionTypes.DETAIL_VIEW_FILTER_REQUEST,
});

const getDetailViewRequest = () => ({
  type: actionTypes.DETAIL_VIEW_REQUEST,
});

const getDetailGroupViewRequest = (cnt) => ({
  type: actionTypes.DETAIL_GROUP_VIEW_REQUEST,
  cnt,
});

const getConditionOpertorViewSuccess = (payload, tab) => ({
  type: actionTypes.DETAIL_VIEW_FILTER_SUCCESS,
  payload,
  tab,
});

const getReportDetailViewRequest = () => ({
  type: actionTypes.REPORT_DETAIL_VIEW_REQUEST,
});

const getReportDetailViewFilterRequest = () => ({
  type: actionTypes.REPORT_DETAIL_VIEW_FILTER_REQUEST,
});

const getReportsDetailViewFilterSuccess = (payload, tab, cnt) => ({
  type: actionTypes.REPORT_DETAIL_VIEW_FILTER_SUCCESS,
  payload,
  tab,
  cnt
});
const getReportDetailViewSuccess = (payload, tab) => ({
  type: actionTypes.REPORT_DETAIL_VIEW_SUCCESS,
  payload,
  tab,
});

const getReportDetailViewFailure = (error) => ({
  type: actionTypes.REPORT_DETAIL_VIEW_FAILURE,
  error,
});

const getDetailViewSuccess = (payload, tab) => ({
  type: actionTypes.DETAIL_VIEW_SUCCESS,
  payload,
  tab,
});

const getGroupPagDetailViewSuccess = (payload, tab, cnt) => ({
  type: actionTypes.DETAIL_GROUP_VIEW_SUCCESS,
  payload,
  tab,
  cnt
});


const getDetailViewFailure = (error) => ({
  type: actionTypes.DETAIL_VIEW_FAILURE,
  error,
});

const getUpdateBPMRequest = () => ({
  type: actionTypes.BPM_UPDATE_REQUEST,
});

const getUpdateBPMSuccess = (payload,tab) => ({
  type: actionTypes.BPM_UPDATE_SUCCESS,
});
const getUpdateBPMFailure = (error) => ({
  type: actionTypes.BPM_UPDATE_FAILURE,
  error,
});

// to get module field type - Ritesh
const getModuleFieldTypeRequest = () => ({
  type: actionTypes.MODULE_FIELD_TYPE_REQUEST,
});
const getModuleFieldTypeSuccess = (payload) => ({
  type: actionTypes.MODULE_FIELD_TYPE_SUCCESS,
  payload,
});
const getModuleFieldTypeFailure = (error) => ({
  type: actionTypes.MODULE_FIELD_TYPE_FAILURE,
  error,
});
// to get module field type - Ritesh

export const getDetailView = (module, id,uid=null) => async (dispatch) => {

  try {
    dispatch(getDetailViewRequest());
    const res = await api.get(
      `/V8/layout/DetailView/${module}/${id}`,
    );
    if (res.ok) {
      dispatch(getDetailViewSuccess(res.data, module));
      return res.data;
    }
    dispatch(getDetailViewFailure(res.data.errors.detail));
  } catch (e) {
    dispatch(getDetailViewFailure(e));
  }
};

// to get email module detailview - Roshan

export const getEmailsDetailView = (module,id,msgno,uid,crmEmailId='') => async (dispatch) => {

  try {
    dispatch(getDetailViewRequest());
    //console.log("crmEmailId",crmEmailId);
    let crmEmailIdParam = crmEmailId?`&emailCRMId=${crmEmailId}`:'';
    const res = await api.get(`/V8/emailsetting/emaildetailview?folder_name=INBOX&folder=inbound&inbound_email_record=${id}&uid=${uid}&msgno=${msgno}&data[attributes][]=1&data[type]=InboundEmail${crmEmailIdParam}`,)
    if (res.ok) {
      dispatch(getDetailViewSuccess(res.data, module));
      return res;
    }
    dispatch(getDetailViewFailure(res.data.errors.detail));
  } catch (e) {
    dispatch(getDetailViewFailure(e));
  }
};
/*
export const getAOR_ReportsDetailView = (module, id, pageNo = 1,group_val = '', pageSize = 20,sort = '',filter = '',cnt = 1) => async (dispatch) => {  
  try {
    if(group_val.length > 0)
    {
      dispatch(getDetailGroupViewRequest(cnt));
    }
    else
    {
      dispatch(getDetailViewRequest());
    }

    let url = `/V8/layout/ReportDetailView/${module}/${id}`;

    let offset = (pageNo>0)?(pageNo - 1) * pageSize:0;
        
    let para_data = {offset:""+offset, group_value:group_val};
    if(filter)
    {
      para_data.parameter_id = filter.parameter_id;
      para_data.parameter_operator = filter.parameter_operator;
      para_data.parameter_type = filter.parameter_type;
      para_data.parameter_value = filter.parameter_value;
    }
    para_data = JSON.stringify(para_data);
    const res = await api.post(url,para_data);
    if (res.ok) {
      if(group_val.length > 0)
      {        
        dispatch(getGroupPagDetailViewSuccess(res.data, module,cnt));
      }
      else
      {
        dispatch(getDetailViewSuccess(res.data, module));
      }
      return;
    }
    dispatch(getDetailViewFailure(res.data.errors.detail));
  } catch (e) {
    dispatch(getDetailViewFailure(e));
  }
};*/

export const getReportsDetailView = (module, id, pageNo = 1, group_val = '', pageSize = 20, sort = '', filter = '', cnt = 1, isFilter) => async (dispatch) => {
  try {
    if (group_val.length > 0) {
      dispatch(getDetailGroupViewRequest(cnt));
    }
    else if (isFilter) {
      dispatch(getReportDetailViewFilterRequest());
    }
    else {
      dispatch(getDetailViewRequest());
    }

    let url = `/V8/layout/ReportDetailView/${module}/${id}`;

    let offset = (pageNo > 0) ? (pageNo - 1) * pageSize : 0;

    let para_data = { offset: "" + offset, group_value: group_val };
    if (filter) {
      //para_data.parameter_field = filter.parameter_field;
      para_data.parameter_id = filter.parameter_id;
      para_data.parameter_operator = filter.parameter_operator;
      para_data.parameter_type = filter.parameter_type;
      para_data.parameter_value = filter.parameter_value;
    }
    para_data = JSON.stringify(para_data);
    const res = await api.post(url, para_data);
    if (res.ok) {
      // if(filter)
      // {
      //   dispatch(getReportsDetailViewFilterSuccess(res.data, module,cnt));
      // }
      if (group_val.length > 0) {
        dispatch(getGroupPagDetailViewSuccess(res.data, module, cnt));
      }
      else {
        if (isFilter) {
          dispatch(getReportsDetailViewFilterSuccess(res.data, module));
        } else {
          dispatch(getDetailViewSuccess(res.data, module));
        }

      }
      return;
    }
    dispatch(getDetailViewFailure(res.data.errors.detail));
  } catch (e) {
    dispatch(getDetailViewFailure(e));
  }
};

export const getListViewReportData = (
  tab,
  id,
  pageNo = 1,
  pageSize = 20,
  sort,
  filterQuery,
) => async (dispatch) => {
  try {
    //dispatch(getDetailViewRequest());

    let url = `/V8/layout/ReportDetailView/${tab}/${id}`;
    //console.log("Page " + pageNo + " pageSize");
    let offset = (pageNo - 1) * pageSize;
    let para_data = `{"offset":"${offset}"}`;

    /*const res = await api.post(
      `/V8/layout/ReportDetailView/${module}/${id}`,
    );*/

    const res = await api.post(url, para_data);

    if (res.ok) {
     // console.log("Success PAgination");
      dispatch(getDetailViewSuccess(res.data, tab));
      return;
    }
    return dispatch(getDetailViewFailure(getError(res)));
  } catch (e) {
    //console.log("Error PAgination"+e);
    dispatch(getDetailViewFailure(e));
  }
};


export const getConditionOpertorView = () => async (dispatch) => {

  try {
    dispatch(getConditionOpertorViewRequest());
    let url1 = `/V8/reportapi/getModuleOperatorField`;
    let url2 = `/V8/reportapi/getFieldTypeOptions`;
    let url3 = `/V8/reportapi/getModuleFieldType`;

    let para_data = `[{
      "aor_module": "Leads",
      "aor_fieldname": "status",
      "aor_value": "Equal_To",
      "rel_field":"",
      "aor_type":"Multi"
    },{
      "aor_module": "Leads",
      "aor_fieldname": "date_entered",
      "aor_value": "Equal_To",
      "rel_field":"",
      "aor_type":"Multi"
    }]`;
    const res = await api.post(url1, para_data);

    //const res2 = await api.post(url2,para_data); 
    //const res3 = await api.post(url3,para_data); 

    //console.log("res = ", res);
    if (res.ok) {
      dispatch(getConditionOpertorViewSuccess(res.data, 'fields'));
      return;
    }
    //dispatch(getDetailViewFailure(res.data.errors.detail));
  } catch (e) {
    //dispatch(getDetailViewFailure(e));
  }
};

export const getModuleFieldType = (rowNum, aor_module, aor_fieldname, aor_newfieldname, aor_value, aor_type, rel_field) => async (dispatch) => {

  try {
    //dispatch(getModuleFieldTypeRequest());
    const postData = {
      aor_module: aor_module,
      aor_fieldname: aor_fieldname,
      aor_newfieldname: aor_newfieldname,
      aor_value: aor_value,
      aor_type: aor_type,
      rel_field: rel_field,
      condition: rowNum
    };
    const res = await api.post(`/V8/reportapi/getModuleFieldType`, postData);

    if (res.ok) {
      //dispatch(getModuleFieldTypeSuccess(res.data));
      //console.log("getModuleFieldType res", res);
      return res;
    }
    //dispatch(getModuleFieldTypeFailure(res.data.errors.detail));
  } catch (e) {
    //dispatch(getModuleFieldTypeFailure(e));
  }
};

export const printAsPdf = (data) => async (dispatch) => {
  let param = {
    extraTask: data.extraTask,
    templateId: data.templateId
  }

  try {
    return await api.post(`/V8/layout/QuotesInvoicePDFView/${data.module}/${data.report_id}`, param);
  } catch (e) {
    return e;
  }
}
export const emailCustomerReview = (module,id) => async (dispatch) => {
  
  let payload = {
    data: {
      type: module,
      id: id,
      attributes: {
        stage:'Delivered',
        approval_status:'Pending_Approval'
      }
    }
  };
  payload = JSON.stringify(payload);
  try {
    //console.log("Data",data);
   //return {ok:true,data:{data:[]}};
    let res =  await api.patch(`/V8/module`, payload);
    if(res.ok)
    {
      try {
        dispatch(getDetailViewRequest());
        const res = await api.get(
          `/V8/layout/DetailView/${module}/${id}`,
        );
        if (res.ok) {
          dispatch(getDetailViewSuccess(res.data, module));
          return res.data;
        }
        dispatch(getDetailViewFailure(res.data.errors.detail));
      } catch (e) {
        dispatch(getDetailViewFailure(e));
      }
    }
  } catch (e) {
    // console.log("error emailCustomerReview",e);
    return e;
  }
}

export const updateBpmStep = (
  stepid,condition_task_id,sla_m_d_id,sla_m_d_task_con_id,moduleName,moduleId,sla_wf_id,module,oldData
) => async (dispatch) => {
  try {
    dispatch(getUpdateBPMRequest());
    
    let url = `/V8/bpm/updatestep`;
    let para_data = `{"stepid":"${stepid}","condition_task_id":"${condition_task_id}","sla_m_d_id":"${sla_m_d_id}","sla_m_d_task_con_id":"${sla_m_d_task_con_id}","module_name":"${moduleName}","module_id":"${moduleId}","sla_wf_id":"${sla_wf_id}"}`;

    const res = await api.post(url, para_data);

    if (res.ok) {   
     oldData[module].data.templateMeta.bpm = clone(res.data && res.data.data?res.data.data:[]);
     dispatch(getUpdateBPMSuccess(oldData[module], module));
     toast(pathOr("Something went wrong!",["data","data","message"],res));
    }else{
      dispatch(getUpdateBPMFailure("Something went wrong!"));
      toast("Something went wrong!");
    }    
  } catch (e) {
    dispatch(getUpdateBPMFailure(e));
  }
};

